import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context/index.js";
import { FILE_UPLOAD_TYPE } from "../types.js";
import { FileViewer } from "./file-viewer.js";
const File = ({ node, nodeIndex, NodeViewContainer }) => {
  const { config, helpers } = useContext(RicosViewerContext);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { key: node.id, node, nodeIndex }, /* @__PURE__ */ React.createElement(
    FileViewer,
    {
      nodeId: node.id,
      componentData: node.fileData,
      settings: config[FILE_UPLOAD_TYPE],
      helpers
    }
  ));
};
var file_default = File;
export {
  file_default as default
};
//# sourceMappingURL=file.js.map

import "@wix/ricos/css/plugin-file-upload-viewer.global.css";